module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S3c9g0/tc-custom/9781398441453.jpg?1705540911248",
      "alt": "This image is the cover for the book Sometime in August"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sometime in August\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sometimes you need a lifetime to tell a story. Sometimes you only need four days. Heather Thompson is a 20-year-old with an arguably great life: the makings of a dream career, supportive friends and family, and a relationship lifted right out of a romance novel. But that doesn’t mean she isn’t struggling. Sometime in August is an honest, no-holds-barred account of mental ill-health in a young adult, which follows four life-changing days in Heather’s life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy Taylor Cook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amy Taylor Cook has been an aspiring author since she could hold a pen. Her debut novel Sometime in August is based partly on her own experiences with mental health, and it aims to discuss the topic in a blunt and relatable manner. Amy grew up in East Kilbride, Greater Glasgow, where she currently lives with her fiancé along with pet snails and a huge collection of books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0